import { render, staticRenderFns } from "./Regex.vue?vue&type=template&id=26839a8b"
import script from "./Regex.vue?vue&type=script&lang=js"
export * from "./Regex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports